export default __webpack_public_path__ + "static/media/instagram.da8c084b.svg";